export const HOMEPAGE_GET_DATA = 'HOMEPAGE_GET_DATA';
export const HOMEPAGE_CMS_DATA = 'HOMEPAGE_CMS_DATA';
export const HOMEPAGE_NEWS_DATA = 'HOMEPAGE_NEWS_DATA';
export const OTHER_WEIR_APPS = 'OTHER_WEIR_APPS';
export const OTEHR_WEIR_APPS_CMS_DATA = 'OTEHR_WEIR_APPS_CMS_DATA';
export const SHOW_LOADER = 'SHOW_LOADER';
